function initStripeService () {
  return new Promise((resolve, reject) => {
    if (window.Stripe) {
      resolve()
      return
    }
    import(/* webpackChunkName: "scriptjs" */ 'scriptjs')
      .then(script => {
        if (!window.navigator.onLine) {
          reject(new Error('no internet connection: could not initialize payment system Stripe'))
          return
        }
        script.default('https://js.stripe.com/v3/', () => {
          resolve()
        })
      })
  })
}

export {
  initStripeService
}
